<ng-container *ngIf="isLoaded; else loading">
  <section class="chat">
  <ng-container *ngIf="(chatAll$ | async) as chatAll">
    <div class="chat__wrapper" [ngClass]="{'chat__wrapper--empty': !chatAll.length}">
      <ng-container *ngIf="chatAll.length else emptyRoomChats">
        <div class="chat__aside" [ngClass]="{'chat__aside--open' : !(chatCurrent$ | async)?.ChatID}">
          <app-chat-room *ngFor="let room of chatAll"
            [status]="room.User.IsOnline ? 'online' : 'offline'"
            [chatId]="room.ChatID"
            [title]="room.User.UserFirstName + ' ' + room.User.UserMidName"
            [text]="room.Messages[room.Messages.length - 1]?.MsgText || ''"
            [date]="room.ChatLastMsgDT"
            [isNew]="room.User.IsOnline && false"
            [active]="room.ChatID === (chatCurrent$ | async)?.ChatID"
            (click)="currentChat(room)"
          ></app-chat-room>
          <ui-button (click)="addChat()" class="invite" icon="add" [outline]="true">Добавить контакт</ui-button>
        </div>
        <div class="chat__messages"
             [ngClass]="{'chatNull': !(chatCurrent$ | async)?.Messages?.length || !(chatCurrent$ | async)?.User?.UserRegConfirmed}">
          <ng-container *ngIf="(chatCurrent$ | async) as chatOpen else emptyTargetRoom">
            <ng-container *ngIf="chatOpen.User.UserRegConfirmed else notRegist">
              <div class="chat-messages__head">
                <app-chat-head [title]="chatOpen.User.UserFirstName + ' ' + chatOpen.User.UserMidName" (callActive)="callActive()" (deleteChatEvent)="deleteChat()"></app-chat-head>
              </div>
              <div class="chat-messages__body" #bodyChat [ngClass]="{'chat-messages__body--emptyChat': !chatOpen.Messages?.length}"><!---->
                <ng-container *ngIf="chatOpen.Messages.length else emptyChat">
                  <ng-container *ngFor="let message of chatOpen.Messages">
                    <app-chat-message *ngIf="message.MsgAuthor !== 'system'"
                                      [title]="message.MsgAuthor === 'convicted'
                                      ? chatOpen.Convicted.ConvictedFirstName + ' ' + chatOpen.Convicted.ConvictedMidName
                                      : chatOpen.User.UserFirstName + ' ' + chatOpen.User.UserMidName"
                                      [date]="message.MsgDT"
                                      [text]="message.MsgText"
                                      [isRead]="message.MsgIsRead"
                                      [status]="message.MsgState"
                                      [images]="message.Attachments"
                                      [notAvatar]="message.MsgAuthor === 'convicted'"
                                      ></app-chat-message>
                    <app-chat-message-system *ngIf="message.MsgAuthor === 'system'" [data]="message"></app-chat-message-system>
                  </ng-container>
                </ng-container>

              </div>
              <div class="chat-messages__footer">
                <app-chat-footer></app-chat-footer>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</section>
</ng-container>

<ng-template #loading>
  <section class="loading">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </section>
</ng-template>

<ng-container *ngIf="callActive$ | async">
  <app-jitsi *ngIf="(authService.name$ | async) as name" [name]="name" [room]="roomCode"></app-jitsi>
</ng-container>

<ng-template #emptyTargetRoom>
  <div class="emptyTargetRoom">
    <h3>Выберите диалог</h3>
    <p>Отправьте первое сообщение</p>
  </div>
</ng-template>
<ng-template #emptyChat>
  <div class="emptyChat">
    <h3>Диалог пуст</h3>
    <p>Отправьте первое сообщение</p>
  </div>
</ng-template>
<ng-template #emptyRoomChats>
  <div class="emptyRooms">
    <h3>Нет добавленных контактов</h3>
    <p>Вы можете отправить приглашение человеку, когда человек зарегистрируется в системе вы сможете с ним общаться</p>
    <ui-button (click)="addChat()">Отправить приглашение</ui-button>
  </div>
</ng-template>

<ng-template #notRegist>
  <div class="arrow" (click)="back()"><ui-icon nameIcon="arrow_back"></ui-icon> <span>Назад</span></div>
  <div class="notRegist" *ngIf="(this.chatCurrent$ | async) as chatCurrent">
    <h3>Данный контакт еще не зарегистрировался</h3>
    <ng-container *ngIf="chatCurrent.User.UserCanBeInvited">
      <p>Приглашение было отправлено {{ chatCurrent.User.UserLastInviteDT | date: 'dd.MM.yyyy' }}.<br>Выслать приглашение еще раз?</p>
      <ui-button *ngIf="chatCurrent.User.UserCanBeInvited" (click)="inviteCurrentChat(chatCurrent.User.UserPhone)">Отправить приглашение</ui-button>
    </ng-container>
    <ng-container *ngIf="!chatCurrent.User.UserCanBeInvited">
      <p>Приглашение было отправлено  {{ chatCurrent.User.UserNextInviteDT | date: 'dd.MM.yyyy' }}.<br>Через 3 дня возможна повторная отправка</p>
    </ng-container>
  </div>
</ng-template>
